import axios from 'axios';
import { GEOCODER_API_URL } from 'config/URL/URL';
axios.defaults.withCredentials = true;

const isAbsoluteUrl = (value = '') => /^https?:\/\//i.test(value);
const withGeocoderBase = (path = '') =>
    isAbsoluteUrl(path) ? path : `${GEOCODER_API_URL || ''}${path}`;

export const geocodeByAddr = async ({ address, addrType, srid }) => {
    const { data } = await axios.get(withGeocoderBase('/api/geoCodeByAddr'), {
        params: { addr: address, addrType, srid },
    });
    return data; // 서버가 빈 문자열을 줄 수 있음
};

export const startGeocodeFile = async (formData) => {
    // 업로드 시작 (SSE는 훅에서 ...)
    return fetch(withGeocoderBase('/api/geoCodeByFile'), {
        method: 'POST', body: formData,
        credentials: 'include',
    });
};

export async function startGeocodeFileAt(url, formData) {
    return fetch(withGeocoderBase(url), {
        method: 'POST',
        body: formData,
        credentials: 'include',
    });
}

export const downloadResultFile = async (fileName) => {
    const resp = await axios.get(withGeocoderBase('/api/downloadFile'), {
        params: { fileName },
        responseType: 'blob',
    });
    return resp; // blob 응답
};

export async function downloadResultFileAt(url, fileName) {
    return axios.get(withGeocoderBase(url), {
        params: { fileName },
        responseType: 'blob',
    });
}

export const openSSE = (url) => new EventSource(withGeocoderBase(url));

export async function reverseGeocode({ x, y, addrType, srid }) {
    if (x == null || y == null) throw new Error('좌표(X/Y)가 비어있습니다.');
    console.log(addrType);
    const { data } = await axios.get(withGeocoderBase('/api/reverse/geoCodeByCoord'), {
        params: { xcoord: x, ycoord: y, addrType: addrType, srid: srid },
    });
    if (!data) return null;
    return data; // { roadAddress?, jibunAddress?, x?,y?, x3857?,y3857? ... c}
}
